import { indexDB } from 'ynf-core-middleware'
import axios from 'axios';

// 多语转化
export async function multilingual(pageStore, data, domainKey, cBillnum) {
    // const dbInstance = await indexDB.init("ynfMultiDB", 1, [
    //     { tableName: "ynfMultiCache", options: { keyPath: "ynfMultiId", autoIncrement: false } }
    // ])
    // const tplId = pageStore.params.tplId;
    // const locale = rootStore.context.locale;
    // const res = await dbInstance.query("ynfMultiCache", (item) => item.ynfMultiId === `${cBillnum}_${locale}`)
    // let multiRes = res && res.length > 0 ? res[0].data : undefined;
    // if (!res || !multiRes) {
        try {
            let url = `${location.origin}/mdf-node/qtmProxy/ypd/bill/multiTrans?billNo=${cBillnum}&domainKey=${domainKey}`
            let newRes = await axios({
                url,
                method: 'get',
                withCredentials: true,
            });
            if (newRes.data.code === 200) {
                let multiRes = newRes.data.data;
                data.forEach(column => {
                    Object.keys(column).forEach(item => {
                        const value = column[item]
                        // 多语如果key和value相等的话就不替换了
                        if (item.indexOf('_resid') > -1 && multiRes[value] && multiRes[value] != value) {
                            // 要替换的字段
                            const replaceField = item.replace('_resid', '')
                            // 替换
                            column[replaceField] = multiRes[value]
                        } else if (item.indexOf('_resid') > -1 && multiRes[value] === undefined) {
                            console.error(`没有找到${value}的多语配置, 请完善配置!`)
                        }
                    })
                })
            }
            // this.db?.insert('ynfMultiCache', { refCode: `${cBillnum}_${locale}`, value: multiRes })
            return data;
        } catch (error) {
            return data;
        }
    // }
}